import { render, staticRenderFns } from "./BomFormats.vue?vue&type=template&id=3b5f48bc&"
import script from "./BomFormats.vue?vue&type=script&lang=js&"
export * from "./BomFormats.vue?vue&type=script&lang=js&"
import style0 from "./BomFormats.vue?vue&type=style&index=0&id=3b5f48bc&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b5f48bc')) {
      api.createRecord('3b5f48bc', component.options)
    } else {
      api.reload('3b5f48bc', component.options)
    }
    module.hot.accept("./BomFormats.vue?vue&type=template&id=3b5f48bc&", function () {
      api.rerender('3b5f48bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/configuration/BomFormats.vue"
export default component.exports